import {
  ADD_TEAM_FAIL,
  ADD_TEAM_SUCCESS,
  ADD_TEAM_REQUEST,
  DELETE_TEAM_REQUEST,
  DELETE_TEAM_SUCCESS,
  GETDETAIL_TEAM_REQUEST,
  GETDETAIL_TEAM_FAIL,
  GETDETAIL_TEAM_SUCCESS,
  UPDATE_TEAM_FAIL,
  UPDATE_TEAM_SUCCESS,
  UPDATE_TEAM_REQUEST,
  DELETE_TEAM_FAIL,
  GETALL_TEAM_FAIL,
  GETALL_TEAM_SUCCESS,
  GETALL_TEAM_REQUEST,
  CLEAR_TEAM_RECORD,
} from "../constant/TeamConstant";

const initialState = {
  loading: false,
  action: "Team",
  result: [],
  response: {},
  singledata: [],
  message: "",
  error: "",
};

const TeamReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TEAM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GETALL_TEAM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case GETDETAIL_TEAM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_TEAM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_TEAM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_TEAM_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_TEAM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case UPDATE_TEAM_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };
    case DELETE_TEAM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),

        message: action.message,
      };
    case DELETE_TEAM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case CLEAR_TEAM_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };

    default:
      return state;
  }
};

export default TeamReducer;
